import { assertNever } from "../lib/utils";
import React, { useCallback, useState } from "react";
import { Button } from "./Button";
export const FILTER_CHIP_VARIANTS = ["primary", "secondary"];
// `bg-selected` is the NavTabPill active token; hover/active are pinned so the chip stays put.
function selectedButtonProps(variant) {
    switch (variant) {
        case "primary":
            return { variant: "primary" };
        case "secondary":
            return {
                variant: "ghost",
                className: "bg-selected hover:bg-selected active:bg-selected",
            };
        default:
            return assertNever(variant);
    }
}
/**
 * A single filter chip whose selection is controlled by the caller. Selected
 * chips are `primary` (filled) or `secondary` (lighter background); unselected
 * chips are ghost. Sets `aria-pressed`.
 * @summary Controlled single filter chip.
 */
export function FilterChip({ label, icon, isSelected = false, variant = "primary", tooltip, onClick, }) {
    return (React.createElement(Button, { size: "xs", label: label, icon: icon, tooltip: tooltip, "aria-pressed": isSelected, onClick: onClick, ...(isSelected ? selectedButtonProps(variant) : { variant: "ghost" }) }));
}
/**
 * A horizontal row of single-select filter chips for narrowing a list or
 * collection to one category at a time, firing onFilterClick on selection.
 * Use it to let users switch between mutually exclusive views or categories
 * (e.g. "Featured", "Research").
 * @summary Single-select category filter chips.
 */
export function FilterChips({ filters, onFilterClick, defaultFilter, variant = "primary", }) {
    const [selectedFilter, setSelectedFilter] = useState(defaultFilter && filters.includes(defaultFilter) ? defaultFilter : null);
    const handleFilterClick = useCallback((filterName) => {
        // Avoid unnecessary re-renders by only triggering event if filter has changed.
        if (filterName !== selectedFilter) {
            setSelectedFilter(filterName);
            onFilterClick(filterName);
        }
    }, [onFilterClick, selectedFilter]);
    return (React.createElement("div", { className: "flex flex-row flex-wrap gap-2" }, filters.map((filterName) => (React.createElement(FilterChip, { key: filterName, label: filterName, isSelected: selectedFilter === filterName, variant: variant, onClick: () => handleFilterClick(filterName) })))));
}
//# sourceMappingURL=FilterChips.js.map